import { MdsPriceStrategy, PriceStrategy } from '@/types';

export const isMdsPriceStrategy = (
  priceStrategy: PriceStrategy
): priceStrategy is MdsPriceStrategy => priceStrategy && priceStrategy.type === 'MdsPriceStrategy';
